// extracted by mini-css-extract-plugin
export default {"parkingTrustArcBanner":"trustArc_parkingTrustArcBanner__Ijwo0"};